import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import Zapbook from 'app/zapbook/components/Zapbook';
import ZapbookLayout from 'app/zapbook/components/ZapbookLayout';
import { matchesQuery } from 'app/common/CommonUtils';

const filterServices = _.memoize(
  (searchTerm, filter, services) => {
    // Quick exit if not actually searching / filtering
    if (searchTerm === '' && filter === 'all') {
      return services;
    }
    const search =
      searchTerm === ''
        ? () => true
        : service => matchesQuery(searchTerm, service.service);

    return (services || []).filter(service => {
      const doesMatchCategory = service.serviceTypes[filter];
      return search(service) && doesMatchCategory;
    });
  },
  (searchTerm, filter) => 'filterServices' + searchTerm + filter
);

const ZapbookStateful = createReactClass({
  displayName: 'ZapbookStateful',
  mixins: [PureRenderMixin],

  getInitialState() {
    return {
      services: [],
      sortCategories: [],
      filterCategories: [],
      filteredServiceIds: [],
      nonMatchingServiceIds: [],
      searchTerm: '',
    };
  },

  onSearchServices(value) {
    const { sortServices } = this;
    const emptySearchTerm = value === '';
    const isOnlyFirstHundred =
      emptySearchTerm &&
      (this.props.isZapbookPage || this.props.isOneServicePage);
    this.setState(
      {
        searchTerm: value,
      },
      sortServices,
      isOnlyFirstHundred
    );
  },

  onTrackFoundApp(value) {
    // Used to track possible missing apps on the Zapboook page. The idea here
    // is that a user might be searching for an app that we do not currently
    // support, so tracking this might point us to what apps we should support.
    this.props.onTrack('Zapbook: Results in search', { searchTerm: value });
  },

  onTrackMissingApp(value) {
    // Used to track possible missing apps on the Zapboook page. The idea here
    // is that a user might be searching for an app that we do not currently
    // support, so tracking this might point us to what apps we should support.
    this.props.onTrack('Zapbook: No results in search', { searchTerm: value });
  },

  sortBy: {
    popular: service => Number(_.get(service, ['dataset', 'popularity'])),
    alphabetical: service =>
      service.service
        .split(' ')
        .join('')
        .toLowerCase(),
    recent: service => Number(_.get(service, ['dataset', 'daysAge'])),
  },

  filterServices(services, filter = this.props.filterBy) {
    const { searchTerm } = this.state;
    return filterServices(searchTerm, filter, services);
  },

  sortServices(
    category = this.props.sortBy,
    filter = this.props.filterBy,
    servicesToSort = this.state.services
  ) {
    const { searchTerm } = this.state;
    const emptySearchTerm = searchTerm === '';
    const isOnlyFirstHundred =
      emptySearchTerm &&
      (this.props.isZapbookPage || this.props.isOneServicePage);
    const services = isOnlyFirstHundred
      ? _.slice(servicesToSort, 0, 100)
      : servicesToSort;

    const sorter = this.sortBy[category] || _.identity;
    const filteredServices = this.filterServices(services, filter);
    const filteredServiceIds = _.sortBy(filteredServices, sorter).map(
      service => service.id
    );
    const nonMatchingServiceIds = _.values(
      _.omit(services, filteredServiceIds)
    ).map(service => service.id);

    // If there are no results after a search is entered, and the search
    // is at least 4 characters long, then send a tracking event for the value
    if (filteredServiceIds.length === 0 && searchTerm.length >= 4) {
      this.onTrackMissingApp(searchTerm);
    }
    // If there are results after a search is entered, and the search
    // is at least 4 characters long, then send a tracking event for the value
    if (filteredServiceIds.length > 0 && searchTerm.length >= 4) {
      this.onTrackFoundApp(searchTerm);
    }

    this.setState({
      filteredServiceIds,
      nonMatchingServiceIds,
    });
  },

  onUpdateHash(category = this.props.sortBy, filter = this.props.filterBy) {
    return this.props
      .updateHash(category, filter)
      .then(() => this.sortServices());
  },

  componentDidMount() {
    // If the services array is empty, it likely means we are on a category page
    // without any results. In this case we should redirect to /404
    // rather than try to sort services that do not exist.
    if (
      this.props.services &&
      this.props.services.length === 0 &&
      this.props.isCategoryPage
    ) {
      this.props.onRedirectTo404();
    }
  },

  UNSAFE_componentWillMount() {
    if (this.props.oldFilterBy) {
      this.props.updateCategory(this.props.oldFilterBy, this.props.sortBy);
    }
    this.sortServices(
      this.props.sortyBy,
      this.props.filterBy,
      this.props.services
    );
    this.onSearchServices = _.debounce(this.onSearchServices, 200);
    this.onTrackMissingApp = _.debounce(this.onTrackMissingApp, 500);

    this.setState({
      services: this.props.services,
      sortCategories: this.props.sortCategories,
      filterCategories: this.props.filterCategories,
      requestAddUpdates: {
        ...this.props.requestAddUpdates,
        isZapbookPage: this.props.isZapbookPage,
        isCategoryPage: this.props.isCategoryPage,
      },
      isOnlyFirstHundred:
        this.props.isOneServicePage || this.props.isZapbookPage,
    });
  },

  render() {
    const { state, props } = this;
    return (
      <ZapbookLayout>
        <Zapbook
          filterBy={props.filterBy}
          filterCategories={state.filterCategories}
          filteredServiceIds={state.filteredServiceIds}
          isCategoryPage={props.isCategoryPage}
          isOneServicePage={this.props.isOneServicePage}
          isOnlyFirstHundred={state.isOnlyFirstHundred}
          isZapbookPage={props.isZapbookPage}
          nonMatchingServiceIds={state.nonMatchingServiceIds}
          onChangeCategory={this.props.updateCategory}
          onSearchServices={this.onSearchServices}
          onUpdateHash={this.onUpdateHash}
          requestAddUpdates={state.requestAddUpdates}
          services={this.state.services}
          servicesHaveLoaded={!_.isEmpty(state.services)}
          sortBy={props.sortBy}
          sortCategories={state.sortCategories}
        />
      </ZapbookLayout>
    );
  },
});

export default ZapbookStateful;
